import * as React from "react";
import { IParagraphBookNowBannerProps } from "./ParagraphBookNowBannerProps";
import { Container } from "./ParagraphBookNowBannerHelpers";
import { graphql } from "gatsby";
import BookNowBanner from "../../common/BookNowBanner/BookNowBanner";

const ParagraphBookNowBanner: React.FC<IParagraphBookNowBannerProps> = (
  props
) => {
  return (
    <Container>
      <BookNowBanner {...props.node} />
    </Container>
  );
};

export const fragment = graphql`
  fragment ParagraphBookNowBanner on paragraph__book_now_banner {
    id
    parent_type
    relationships {
      field_media {
        relationships {
          desktopImage: field_media_image {
            publicUrl
            gatsbyImage(
              width: 1920
              height: 400
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
          mobileImage: field_media_image {
            publicUrl
            gatsbyImage(
              width: 490
              height: 200
              placeholder: BLURRED
              formats: [AUTO, WEBP]
            )
          }
        }
      }
    }
  }
`;
export default ParagraphBookNowBanner;
